(function (para) {
    var p = para.sdk_url; var n = para.name; var w = window; var d = document; var s = 'script'; var x = null; var y = null
    w.sensorsDataAnalytic201505 = n
    w[n] = w[n] || function (a) { return function () { (w[n]._q = w[n]._q || []).push([a, arguments]) } }
    var ifs = ['use', 'track', 'quick', 'register', 'registerPage', 'registerOnce', 'clearAllRegister', 'trackSignup', 'trackAbtest', 'setProfile', 'setOnceProfile', 'appendProfile', 'incrementProfile', 'deleteProfile', 'unsetProfile', 'identify', 'login', 'logout', 'trackLink', 'clearAllRegister']
    for (var i = 0; i < ifs.length; i++) {
        w[n][ifs[i]] = w[n].call(null, ifs[i])
    }
    if (!w[n]._t) {
        /* eslint no-unused-expressions: "off" */
        /* eslint no-sequences: "off" */
        x = d.createElement(s), y = d.getElementsByTagName(s)[0]
        x.async = 1
        x.src = p
        w[n].para = para
        y.parentNode.insertBefore(x, y)
    }
})({
    sdk_url: 'https://static.gomefinance.com.cn/yika/common/sensorsdata-1.16.6.min.js',
    name: 'sensors',
    server_url: process.env.REACT_APP_NODE_ENV === 'production'
        ? 'https://datasink-sensorsdata.gomefinance.com.cn/sa?project=guomeijinrong'
        : 'https://datasink-sensorsdata.gomefinance.com.cn/sa?project=default',
    heatmap: {
        // 开启页面点击事件($WebClick)
        clickmap: 'default',
        // 开启视区停留事件($WebStay)
        scroll_notice_map: 'default'
    },
    // 页面打印收集数据log
    show_log: process.env.REACT_APP_NODE_ENV !== 'production',
    // 配置打通 App 与 H5 的参数
    // use_app_track: true,
    // 单页面自动获取$pageview
    is_track_single_page: true,
    // use_client_time: true,
    send_type: 'beacon',
    app_js_bridge: true
})
// 神策方法封装点击发送埋点
window.$webClick = function (event, data) {
    /* global sensors:true */
    /* eslint no-undef: "error" */
    sensors.quick('trackAllHeatMap', event.target, data)
}
/**
* 神策自定义埋点方法
* @param {*} event 事件变量名
* @param {*} data 事件属性
*/
window.$webTrack = function (event, data, callback) {
    delete data.undefined
    delete data.null
    sensors.track(event, data, function () {
        callback && callback()
    })
}
